import { Component, ViewEncapsulation, Input, HostBinding } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { MatRippleModule } from '@angular/material/core';

import { Shipment } from '../../../../order/models/shipment';
import { UserService } from '../../../services/user.service';
import { User } from '../../../models/user';
import { PRODUCT_OPTIONS, ORDER_NUMBER_OPTIONS, WEIGHT_OPTIONS } from '../../../models/list';
import { GROSS, CUSTOMER, ARTICLE } from '../../../models/settings';
import { NumberPipe } from '../../../pipes/number.pipe';

@Component({
	selector: 'copo-result-shipment-card',
	templateUrl: './result-card-shipment.component.html',
	styleUrl: './result-card-shipment.component.css',
	encapsulation: ViewEncapsulation.Emulated,
	imports: [
		MatRippleModule,
		RouterLink,
		TranslateModule,
		NumberPipe,
	],
})
export class ResultCardShipmentComponent {
	@HostBinding('class.passthrough') readonly passthrough = true;

	@Input() shipment!: Shipment;
	user: User;
	productDisplay: keyof typeof PRODUCT_OPTIONS = ARTICLE;
	orderDisplay: keyof typeof ORDER_NUMBER_OPTIONS = CUSTOMER;
	weightDisplay: keyof typeof WEIGHT_OPTIONS = GROSS;

	constructor(private readonly userService: UserService) {
		this.user = this.userService.user;
	}
}
